import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { FilterType, IFilters } from '@homeviews/models'

export const MEDIA_FEATURE_KEY = 'media'

// todo
type MediaState = {
  filters: IFilters
  activeMedia: any
  selections: number[]
}

const initialMediaState: MediaState = {
  filters: {},
  activeMedia: null,
  selections: [],
}

export const mediaSlice = createSlice({
  name: MEDIA_FEATURE_KEY,
  initialState: initialMediaState,
  reducers: {
    setActiveMedia: (
      state,
      { payload: { media } }: PayloadAction<{ media?: any }>,
    ) => {
      state.activeMedia = media
    },
    setMediaFilter: (
      state,
      {
        payload: { filter, value },
      }: PayloadAction<{ filter: FilterType; value: any }>,
    ) => {
      const currentFilters = state.filters
      if (!value) {
        delete currentFilters[filter]
        state.filters = {
          ...currentFilters,
        }
      } else {
        state.filters = {
          ...state.filters,
          [filter]: value,
        }
      }
    },
    setBulkMediaFilter: (
      state,
      { payload }: PayloadAction<{ filter: FilterType; value: any }[]>,
    ) => {
      let currentFilters = state.filters
      payload.forEach(({ filter, value }) => {
        if (!value) {
          delete currentFilters[filter]
        } else {
          currentFilters = {
            ...currentFilters,
            [filter]: value,
          }
        }
      })
      state.filters = currentFilters
    },
    selectMediaItem: (state, { payload }) => {
      state.selections = [...state.selections, payload]
    },
    unselectMediaItem: (state, { payload }) => {
      const newSelections = state.selections.filter((item) => item !== payload)
      state.selections = newSelections
    },
    clearMediaSelections: (state) => {
      state.selections = []
    },
    clearMediaFilters: (state) => {
      state.filters = {}
    },
  },
})

/*
 * Export reducer for store configuration.
 */
export const mediaReducer = mediaSlice.reducer

export const {
  setMediaFilter,
  setBulkMediaFilter,
  clearMediaFilters,
  setActiveMedia,
  selectMediaItem,
  unselectMediaItem,
  clearMediaSelections,
} = mediaSlice.actions

export const getMediaState = (rootState: unknown): MediaState =>
  rootState[MEDIA_FEATURE_KEY]

export const selectMediaFilters = (rootState: unknown) =>
  rootState[MEDIA_FEATURE_KEY]?.filters

export const selectActiveMedia = (rootState: unknown) =>
  rootState[MEDIA_FEATURE_KEY]?.activeMedia
